var exports = {
  "U": "condensed__BH_jUW",
  "S": "creating__svtbyg",
};

module.exports = exports;
